import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetch3, fetch4, fetch5 } from "../commonApis/commonApis";
const url = process.env.REACT_APP_BASE_URL;

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
}

export const useItemCategoriesCreateMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch4(
        `${url}/api/item-category/`,
        payload
      );

      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ time-slots Created successfully:", data);
      queryClient.invalidateQueries({ queryKey: ["itemCategoriesData"] });
      queryClient.invalidateQueries({ queryKey: ["categoryAllList"] });
      queryClient.invalidateQueries({ queryKey: ["allListCategories"] });
    },
    onError: (error: any) => {
      console.error("❌ time-slots create request failed:", error.message);
    },
  });
};

export const useFetchItemCategoriesData = (
  page: number,
  limit: number,
  searchFor: string
) => {
  return useQuery({
    queryKey: ["itemCategoriesData", page, limit, searchFor],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/item-category?page=${page}&limit=${limit}&searchFor=${searchFor}&type=LM`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

interface UpdateItemCategoriesPayload {
  id: string;
  category: string;
  subCategory: string;
  fields: any;
}
export const useUpdateItemCategories = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      id,
      category,
      subCategory,
      fields,
    }: UpdateItemCategoriesPayload) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/item-category/${id}`,
        "PUT",
        {
          category,
          subCategory,
          fields,
        }
      );

      if (!res.success) {
        throw new Error(res.message || "Failed to update vehicle status");
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ time-slot update successfully:", data);
      queryClient.invalidateQueries({ queryKey: ["itemCategoriesData"] });
      queryClient.invalidateQueries({ queryKey: ["categoryAllList"] });
      queryClient.invalidateQueries({ queryKey: ["allListCategories"] });
      queryClient.invalidateQueries({ queryKey: ["itemSubCategoriesData"] });
    },
    onError: (error: any) => {
      console.error("❌ time-slot update request failed:", error.message);
    },
  });
};

interface UpdateItemCategoriesStatusPayload {
  id: string;
  status: any;
}
export const useUpdateItemCategoriesStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, status }: UpdateItemCategoriesStatusPayload) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/item-category/${id}/status`,
        "PATCH",
        {
          status,
        }
      );

      if (!res.success) {
        throw new Error(res.message || "Failed to update vehicle status");
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ time-slot status updated successfully:", data);
      queryClient.invalidateQueries({ queryKey: ["itemCategoriesData"] });
      queryClient.invalidateQueries({ queryKey: ["categoryAllList"] });
      queryClient.invalidateQueries({ queryKey: ["allListCategories"] });
      queryClient.invalidateQueries({ queryKey: ["itemSubCategoriesData"] });
    },
    onError: (error: any) => {
      console.error("❌ time-slot status update failed:", error.message);
    },
  });
};

export const useCategoryAllListData = () => {
  return useQuery({
    queryKey: ["categoryAllList"],
    queryFn: async () => {
      const res = await fetch3(`${url}/api/product-item/category/all`, "get");

      if (!res || !res.data) {
        return res.message;
      }

      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useSUbCategoriesListData = (categoryId: string) => {
  return useQuery({
    queryKey: ["itemSubCategoriesData", categoryId],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/product-item/sub-category/${categoryId}`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
};
